import { Suspense, lazy, type FC } from 'react';
import { useSelector } from 'react-redux';

// types
import { type AuctionTooltipContentType } from './PdpSharedAuctionTooltipType';

const PdpSharedAuctionTooltip = lazy(
    () => import(/* webpackChunkName: "PdpSharedAuctionTooltip" */ './PdpSharedAuctionTooltip')
);

type Props = {
    type: AuctionTooltipContentType;
};

type RelayVariables = {
    isClient: boolean;
};

type ReduxStoreType = {
    relayVariables: {
        variables: RelayVariables;
    };
};

export const PdpSharedAuctionTooltipLazy: FC<Props> = ({ type }) => {
    const { isClient } = useSelector<ReduxStoreType, RelayVariables>(
        relay => relay?.relayVariables?.variables || {}
    );

    if (!isClient) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <PdpSharedAuctionTooltip type={type} size="medium" />
        </Suspense>
    );
};
